import {
  SendVerificationLinkToUserQuery,
  UserDetails,
  CreateUserFromWebClientQuery,
  CreateUserFromWebClientMessage
} from "../../autogenerated/ZoomBridge";
import { Logger } from './../../logger/Logger';

export default class CreateNewUser {
  constructor() {
    this.logger = new Logger('CreateNewUser');
  }

  /**
   * 
   * @param {string} email 
   * @param {string} firstName 
   * @param {string} lastName 
   * @returns {Promise.<Boolean,ErrorId>}
   */
  sendEmailVerificationLink(email, firstName, lastName) {
    let sendVerificationLinkToUserQuery = new SendVerificationLinkToUserQuery();
    let message = new UserDetails();
    message.setEmail(email).setFirstName(firstName).setLastName(lastName);
    sendVerificationLinkToUserQuery.message = message;
    return sendVerificationLinkToUserQuery.run();
  }

  /**
   * 
   * @param {string} email 
   * @param {string} firstName
   * @param {string} lastName
   * @param {string} passCode
   * @param {string} password
   */
  createUser(email, firstName, lastName, passCode, password, profileFileId, profilePicName) {
    const query = new CreateUserFromWebClientQuery();
    /**
     * @type{CreateUserFromWebClientMessage}
     */
    const message = new CreateUserFromWebClientMessage();
    message.setUserDetails(new UserDetails().setEmail(email).setFirstName(firstName).setLastName(lastName).setProfileFileId(profileFileId).setProfilePicName(profilePicName));
    message.setVerificationCode(passCode).setPassword(password);
    query.message = message;    
    return query.run();    
  }

}